<template>
  <div class="moreWays">
    <!-- <div id="fb-root"></div>
    <script async
            defer
            crossorigin="anonymous"
            src="https://connect.facebook.net/zh_CN/sdk.js#xfbml=1&version=v7.0&appId=461897317839509&autoLogAppEvents=1"></script>

    <div class="fb-login-button"
         data-size="large"
         data-button-type="continue_with"
         data-layout="default"
         data-auto-logout-link="false"
         data-use-continue-as="false"
         data-width=""></div> -->
    <div class='btn-box'>
      <button v-google-signin-button="clientId"
              v-show="googleInit"
              @click='loging'
              class="google-signin-button">
        <svg class="icon"
             aria-hidden="true">
          <use xlink:href="#icon-google_plus"></use>
        </svg>
      </button>

      <button v-facebook-signin-button="appId"
              v-show="facebookInit"
              @click='loging'
              class="facebook-signin-button">
        <svg class="icon"
             aria-hidden="true">
          <use xlink:href="#icon-facebook"></use>
        </svg>
      </button>
    </div>

    <!-- <button @click="fbtest">fbtest</button> -->

    <!-- <facebook-login class="faceBookSignin"
                    @click="facebookClick"
                    appId="319129988630331"
                    logoutLabel="Log In To Facebook"
                    @logout="onLogout"
                    @get-initial-status="getFacebookUserData"
                    @login="OnFacebookAuthSuccess"></facebook-login> -->
  </div>
</template>

<script>
import GoogleSignInButton from '../../utils/google.js'
import FacebookSignInButton from '../../utils/facebook.js'
export default {
  name: 'moreWays',
  directives: {
    GoogleSignInButton,
    FacebookSignInButton
  },
  data () {
    return {
      loaingId: '',
      googleInit: false,
      facebookInit: false,
      appId: '1727171881173031',//正式
      clientId: '657997517642-v6s8tnkf07p4k6qk0v4r8qg8p95qkt91.apps.googleusercontent.com'//正式
      // appId: '502103870610957',
      // clientId: '330371767091-prvn37v21o6pcfebu54r62f8vrsp1l9m.apps.googleusercontent.com'
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    loging () {
      this.loaingId = this.$loading();
    },
    OnGoogleAuthSuccess (idToken) {
      this.$axios.post(this.apiUrl.API.GgLogin, {
        idToken: idToken,
        terminalType: 'APP_GAME_SHOP'
      })
        .then((res) => {
          if (res.data.resCode == 'C502570000000') {
            this.loaingId.close();
            this.$store.commit('login', res);
            this.$emit('childs', false);//登陆成功,关闭弹窗
            // sessionStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
            // sessionStorage.setItem('userToken', res.data.userToken)
            // this.$store.state.count = res.data.userInfo
          } else {
            this.loaingId.close();
          }
        })


      // this.$http.post('/extUser/gpLogin', { idToken: idToken }).then((res) => {
      //   if (res.resCode == 'C502570000000') {
      //     this.$store.commit('setToken', res);
      //     if (this.$store.state.gameName == 'bbg') {
      //       this.$router.push({ path: '/gameAccount' });
      //     } else {
      //       this.$router.push({ path: '/' });
      //     }
      //     vm.$vux.loading.hide()
      //   }
      // })
    },
    OnGoogleAuthFail (error) {
      this.loaingId.close();
      // this.$layer.open({
      //   content: this.mylayerHtml('tipsHtml', vm.$t('interact.' + res.resCode)),
      //   className: 'tips',
      //   btn: [this.$t('Confirm')],
      //   shadeClose: false,
      //   yes (index, $layer) {
      //     vm.$layer.closeAll();
      //     // 函数返回 false 可以阻止弹层自动关闭，需要手动关闭
      //   }
      // })
    },
    OnGoogleInit () {
      this.googleInit = true;
    },
    OnFacebookInit () {
      this.facebookInit = true;
    },
    OnFacebookAuthSuccess (idToken) {
      console.log(idToken)
      if (idToken) {
        // var accessToken = res.response.authResponse.accessToken;
        this.$http.post(this.apiUrl.API.fbLogin, { idToken: idToken.authResponse.accessToken, extUserId: idToken.authResponse.userID, terminalType: 'APP_GAME_SHOP' }).then((res) => {
          if (res.data.resCode == 'C502570000000') {
            this.loaingId.close();
            this.$store.commit('login', res);
            this.$emit('childs', false);//登陆成功,关闭弹窗
            // sessionStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
            // sessionStorage.setItem('userToken', res.data.userToken)
            // this.$store.state.count = res.data.userInfo
          } else {
            this.loaingId.close();
          }
        })
      }
    },
    OnFacebookAuthFail (error) {
      this.loaingId.close();
      // this.$layer.open({
      //   content: this.mylayerHtml('tipsHtml', '登陆失败，请重新尝试'),
      //   className: 'tips',
      //   btn: ['好的'],
      //   shadeClose: false,
      //   yes (index, $layer) {
      //     vm.$layer.closeAll();
      //     // 函数返回 false 可以阻止弹层自动关闭，需要手动关闭
      //   }
      // })
    }
  },
}
</script>

<style scoped lang="less">
.signBox {
  margin: 18px 0 0 0;
  padding: 0 32px;
  .title {
    font-size: 24px;
  }
  .inpClass {
    margin: 18px 0 0 0;
    height: 28px;
    padding: 0;
    background: #fff;
    box-shadow: 0px 5px 5px 0px rgba(203, 203, 203, 0.1);
    border-radius: 5px;
    text-indent: 10px;
  }
  .inpClass:before {
    content: none;
  }
  .resetPass {
    margin: 17px 0 0 0;
    font-size: 12px;
    font-weight: bold;
    color: rgba(204, 204, 204, 1);
  }
}
.btn-box {
  display: flex;
  justify-content: center;
}
.login {
  margin: 28px 0 0 0;
  background: #f7f8fb;
  .btn {
    // margin: 10px 0 15px 0;
    width: 100%;
    height: 28px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    background: rgba(24, 186, 201, 1);
    border-radius: 14px;
    color: #fff;
  }
  .btn.reg {
    background: transparent;
    border: 1px solid rgba(24, 186, 201, 1);
    color: #18bac9;
    font-size: 14px;
  }
}
.divider {
  margin: 98px 0 0 0;
  width: 100%;
  height: 2px;
  background: rgba(230, 230, 230, 1);
}
.moreWays {
  position: relative;
  .left {
    height: 100px;
    position: absolute;
    top: 24px;
    left: 0;
  }
  .right {
    height: 100px;
    position: absolute;
    top: 82px;
    right: 0;
  }
}
.facebook-signin-button {
  cursor: pointer;
  display: inline-block;
  border: none;
  background: transparent;
  .icon {
    width: 34px;
    height: 34px;
  }
}
.google-signin-button {
  cursor: pointer;
  display: inline-block;
  margin: 0 40px 0 0;
  border: none;
  background: transparent;
  .icon {
    width: 34px;
    height: 34px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/module/moreWays.vue